<template>
    <div v-cloak>
        <div :class="{ 'events-calendar-item': true }" :id="getElementId()">
            <v-calendar
                :first-day-of-week="2"
                :masks="{ title: 'MMMM YYYY' }"
                @dayclick="clicked"
                :attributes="calendar_attributes"
                :from-date="new Date(calendar_group.start_date)"
                :columns="$screens({ default: 1, lg: 2 })"
                :rows="$screens({ default: 4, lg: 2 })"
                :is-expanded="$screens({ default: true, lg: false })"
            />
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import router from "@/router";

export default {
    props: ["calendar_group", "i"],
    data() {
        let attrs = [
            {
                key: "today",
                class: "today-highlight",
                dates: moment(this.calendar_group.start_time).toDate(),
                highlight: true
            }
        ];
        if (this.calendar_group.results && this.calendar_group.results.length > 0) {
            this.calendar_group.results.forEach(e => {
                attrs.push({
                    dot: true,
                    class: "my-dot-class",
                    customData: { event: e },
                    dates: [moment(e.event_time_f).toDate()]
                });
            });
        }
        return {
            calendar_attributes: attrs
        };
    },
    computed: {
        ...mapState("StoreEvent", ["events", "event"]),
        ...mapState("StoreEvent", ["active_tab"]),
        layout() {
            return this.$screens({
                default: {
                    columns: 2,
                    rows: 2
                }
            });
        }
    },
    methods: {
        ...mapMutations("StoreEvent", ["set_active_event"]),

        clicked(day) {
            if (day.attributes && day.attributes[0]) {
                let event = day.attributes[0].customData.event;
                if (event.recurred_item) {
                    this.set_active_event(event);
                } else {
                    this.set_active_event({});
                }
                let event_id = day.attributes[0].customData.event.id;
                router.push({ path: "/events/" + event_id });
            }
        },
        getElementId() {
            return this.calendar_group.is_current ? "current-cal-item" : "";
        }
    }
};
</script>
<style scoped>
.future-item {
    min-height: 30vh;
}

[v-cloak] {
    display: none;
}

#current-cal-item {
    min-height: 60vh;
}

.events-calendar-item {
    margin-top: 40px;
}

.no-results {
    font-size: 1.1rem;
    line-height: 2rem;
    letter-spacing: 0.05em;
    color: #9d9d9d;
    padding-bottom: 1.2rem;
}
</style>
